module.exports = __webpack_public_path__ + "img/neck.718794a0.svg";